<template>

    <v-container grid-list-sm text-xs-left mt-4>

        <v-layout row wrap align-center >

            <v-flex xs12 md8>
                <font size="7">{{getLocalization($route.meta.headerData.title)}}</font>
                <br/><br/>
                <font size="4">
                    {{getLocalization($route.meta.headerData.description)}}
                </font>
            </v-flex>
            <v-flex xs12 md4 class="text-xs-center" >
                <img
                        :src="$route.meta.headerData.img"
                        width="200px"
                ></img>
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
    export default {
        name: "ContentHeader",
        props: [],
        data() {
            return {};
        },

        methods: {
            getLocalization(string){
                return this.$t(string);
            },
        },
    };
</script>

<style lang="scss" scoped>

</style>

